export enum Framework {
  KATALON_STUDIO = 'KATALON_STUDIO',
  CLOUD_STUDIO = 'CLOUD_STUDIO',
}
